/**
 * The application's own default price lists, from the config loaded once via
 * `/api/get-application`.
 *
 * One caller: the basket seed, for the window before the price lists have
 * loaded. These are the lists Norce prices from when a request carries no seed,
 * so naming them changes nothing — it only keeps a basket call from going out
 * with no seed at all.
 *
 * It reflects neither the shopper's sales area nor a signed-in customer's own
 * lists, so it is not an answer to "which lists apply" — that is
 * `norceStore.priceListSeed`, which is worked out per request. Basket lines name
 * no price list at all: the seed on the call is what prices them.
 */
export const getDefaultPriceListIds = (): string | undefined => {
	return useNorceStore().applicationNorce?.Pricelists?.Ids?.join(",");
};
